import { z } from 'zod';

export const emptyToUndefined = <Schema extends z.core.SomeType>(schema: Schema) => {
  const preprocessFn = (val: unknown) => {
    if (typeof val === 'string' && val === '') {
      return undefined;
    }

    return val;
  };

  return z.preprocess(preprocessFn, schema);
};

export const assureIntOrUndefined = <Schema extends z.core.SomeType>(schema: Schema) => {
  const preprocessFn = (val: unknown) => {
    if (typeof val === 'number') {
      return val;
    }

    if (typeof val !== 'string' || val === '') {
      return undefined;
    }

    return parseInt(val, 10);
  };

  return z.preprocess(preprocessFn, schema);
};
